import { start as datadog } from './datadog';

const services = [datadog];

export const initServices = () =>
  ['stage', 'production'].includes(process.env.NODE_ENV) &&
    services.forEach((e) => e());
